<template>
  <v-select
    v-model="model"
    density="compact"
    variant="outlined"
    color="orange50"
    hide-details
    :items="options"
    item-title="label"
    item-value="value"
    :placeholder="placeholder"
    :menu-props="{ contentClass: 'profile-gender-select-menu' }"
    class="profile-gender-select wd-flex-grow-0 wd-w-full md:wd-w-1/2"
  >
    <template #append-inner>
      <FunnowIcon active-class="wd-w-5 wd-h-5" image-path="chevron-down.svg" />
    </template>
  </v-select>
</template>

<script setup lang="ts">
import FunnowIcon from '@/components/icons/funnow-icon.vue'

import type { MemberFormValue } from '@/view-models/member'

interface Props {
  options: { value: number; label: string }[]
  placeholder?: string
}

defineProps<Props>()

const model = defineModel<MemberFormValue>()
</script>

<style lang="scss" scoped>
:deep(.v-select__menu-icon) {
  display: none;
}

.profile-gender-select :deep(.v-field__input),
.profile-gender-select :deep(.v-field__input input::placeholder) {
  color: rgb(var(--v-theme-black50)) !important;
  opacity: 1 !important;
}
</style>

<style lang="scss">
.profile-gender-select-menu .v-list-item__content {
  position: relative;
  z-index: 1;
}
.profile-gender-select-menu .v-list-item:hover > .v-list-item__overlay {
  background-color: $gray30 !important;
  opacity: 1 !important;
}
</style>
